<footer class="footer-section">
  <!-- Imagen de fondo -->
  <div class="footer-background">
    <img [src]="getImageUrl('images/sections/benefits_card/benefits.webp')" alt="La Joya Park Background" class="background-image">
    <div class="dark-overlay"></div>
  </div>

  <!-- Contenido del footer -->
  <div class="footer-content">
    <!-- Título y subtítulo -->
    <div class="footer-header">
      <h2>Contáctanos y afíliate</h2>
      <p>Agenda una cita para obtener tu membresía</p>
    </div>

    <!-- Sección principal dividida en 2 -->
    <div class="main-section">
      <!-- Lado izquierdo: Mapa -->
      <div class="map-section">
        <img [src]="getImageUrl('images/sections/contact_section/Group 238423.webp')" alt="Mapa de ubicación" class="map-image">
      </div>

      <!-- Lado derecho: Formulario -->
      <div class="form-section">
        <app-contact-form></app-contact-form>
      </div>
    </div>
  </div>

  <!-- Imagen de agua solo para móvil -->
  <div class="water-image-section mobile-only">
    <img [src]="getImageUrl('images/sections/contact_section/aguaN.webp')" alt="Agua decorativa" class="water-image">
    <div class="dark-overlay"></div>
  </div>

  <!-- Nueva sección del footer -->
  <div class="footer-bottom">
    <div class="footer-bottom-background">
      <img [src]="getImageUrl('images/sections/contact_section/aguaN.webp')" alt="Agua Background" class="background-image">
      <div class="dark-overlay"></div>
    </div>
    <div class="footer-bottom-content">
      <!-- Lado izquierdo: Información de contacto -->
      <div class="contact-info-section">
        <h3 class="contact-title">Tu lugar en el paraíso te espera</h3>
        <p class="contact-phone">+51 963258147</p>
        <p class="contact-email">soporteLaJoya@gmail.com</p>
        
        <!-- Redes sociales -->
        <div class="social-networks">
          <a href="#" target="_blank" class="social-link">
            <img [src]="getImageUrl('icons/ui/facebook.png')" alt="Facebook" class="social-icon">
          </a>
          <a href="#" target="_blank" class="social-link">
            <img [src]="getImageUrl('icons/ui/instagram.png')" alt="Instagram" class="social-icon">
          </a>
          <a href="#" target="_blank" class="social-link">
            <img [src]="getImageUrl('icons/ui/linkedin.png')" alt="LinkedIn" class="social-icon">
          </a>
          <a href="#" target="_blank" class="social-link">
            <img [src]="getImageUrl('icons/ui/youtube.png')" alt="YouTube" class="social-icon">
          </a>
        </div>
      </div>

      <!-- Lado derecho: Logo grande -->
      <div class="logo-section">
        <img [src]="getImageUrl('logos/variations/la_Joya_footer.png')" alt="La Joya Park" class="footer-logo">
      </div>
    </div>
  </div>
</footer>

<!-- Sección final del footer -->
<div class="footer-final">
  <div class="footer-final-content">
    <p class="copyright">Copyright © 2025 La Joya Park Resort</p>
    <p class="terms">Términos y condiciones</p>
  </div>
</div>
